import {has} from "@/utils/object";
import {storeUserConfig} from "@/service/store/UserConfigHelper";
import {EventBus} from "@/service/EventBus";

const defaultState = {
    lang: 'cs',
    darkMode: false,
    productModels: false,
    vibrate: true,
    beep: true,
    trackTime: true,
    showProductImagesInTasks: false,
    pickFromMobileLocation: false,
    automagicallyChooseInstance: false,
    drawer: true,
};

const stringifyBoolean = value => value ? "true" : "false";
const booleanizeString = value => value !== "false";

const userConfigModule = {
    namespaced: true,
    persistent: true,
    state: {...defaultState},
    actions: {
        replaceConfig({dispatch, state}, config) {
            const remoteState = {};
            config.forEach(el => {
                remoteState[el.key] = el.value;
            });
            for (const key of Object.keys(state)) {
                if (has(remoteState, key)) {
                    dispatch('set', {
                        key,
                        value: typeof defaultState[key] === "boolean" ? booleanizeString(remoteState[key]) : remoteState[key],
                        doNotSendToApi: true
                    });
                }
            }
        },
        set({dispatch}, {key, value, doNotSendToApi}) {
            dispatch(key, value);
            doNotSendToApi || storeUserConfig(key, typeof defaultState[key] === "boolean" ? stringifyBoolean(value) : value);
        },
        lang({commit}, newValue) {
            commit('set', {
                key: 'lang',
                value: newValue
            });
            EventBus.$emit('setLang', newValue);
        },
        darkMode({commit}, newValue) {
            commit('set', {
                key: 'darkMode',
                value: !!newValue
            });
            EventBus.$emit('setDarkMode', !!newValue);
        },
        productModels({commit}, newValue) {
            commit('set', {
                key: 'productModels',
                value: !!newValue
            });
        },
        vibrate({commit}, newValue) {
            commit('set', {
                key: 'vibrate',
                value: !!newValue
            });
        },
        beep({commit}, newValue) {
            commit('set', {
                key: 'beep',
                value: !!newValue
            });
        },
        trackTime({commit}, newValue) {
            commit('set', {
                key: 'trackTime',
                value: !!newValue
            });
        },
        showProductImagesInTasks({commit}, newValue) {
            commit('set', {
                key: 'showProductImagesInTasks',
                value: !!newValue
            });
        },
        pickFromMobileLocation({commit}, newValue) {
            commit('set', {
                key: 'pickFromMobileLocation',
                value: !!newValue
            });
        },
        automagicallyChooseInstance({commit}, newValue) {
            commit('set', {
                key: 'automagicallyChooseInstance',
                value: !!newValue
            });
        },
        drawer({commit}, newValue) {
            commit('set', {
                key: 'drawer',
                value: !!newValue
            });
        },
        clear({commit}) {
            for (const key of Object.keys(defaultState)) {
                commit('set', {
                    key,
                    value: defaultState[key]
                });
            }
        }
    },
    mutations: {
        set(state, keyValue) {
            state[keyValue.key] = keyValue.value;
        }
    },
    getters: {
        lang: state => state.lang,
        darkMode: state => state.darkMode,
        productModels: state => 0 + state.productModels,
        vibrate: state => state.vibrate,
        beep: state => state.beep,
        trackTime: state => state.trackTime,
        showProductImagesInTasks: state => state.showProductImagesInTasks,
        pickFromMobileLocation: state => state.pickFromMobileLocation,
        automagicallyChooseInstance: state => state.automagicallyChooseInstance,
        drawer: state => state.drawer,
    }
};

export default userConfigModule;
